import React, { lazy, Suspense } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';
import PermissionGuard2 from '../../../../../../Layout/PermissionGuard2';
// Lazy load components
const CouponsList = lazy(() => import('../Pages/CouponsList'));

// Import loading overlay
import LoadingOverlay from 'react-loading-overlay';

LoadingOverlay.propTypes = undefined;

function CouponsRoute() {
    const history = useHistory();

    return (
        <Switch>
            <Route
                exact
                path="/:lng/settings/coupons"
                render={() => (
                    <React.Fragment>
                        <Suspense fallback={<Loading />}>
                            <CouponsList history={history} />
                        </Suspense>
                    </React.Fragment>
                )}
            />
        </Switch>
    );
};

export default CouponsRoute;

function Loading() {
    return (
        <>
            <div className="wrapper">
                <span>Loading</span>
            </div>
        </>
    );
}
